import type { Order } from './types';

export const mockOrders: Order[] = [
  {
    id: '1',
    orderNo: 'ORD202501150001',
    paymentNo: 'PAY202501150001',
    productName: '标准云电脑',
    productPrice: 2.5,
    quantity: 1,
    paymentMethod: '按时计费',
    paymentMethodDetail: '按时计费-小时（1.2小时）',
    orderType: '新购',
    orderAmount: 3.0,
    discountAmount: 0,
    actualAmount: 3.0,
    userName: '张三',
    userPhone: '13800138001',
    orderTime: '2025-01-15 10:30:00',
    paymentTime: '2025-01-15 10:32:00',
    paymentChannel: '支付宝',
    status: '已支付',
    type: 'desk'
  },
  {
    id: '2',
    orderNo: 'ORD202501150002',
    paymentNo: 'PAY202501150002',
    productName: 'GPU服务器',
    productPrice: 1200,
    quantity: 1,
    paymentMethod: '包年包月',
    paymentMethodDetail: '包年包月-按月（3月）',
    orderType: '新购',
    orderAmount: 3600,
    discountAmount: 360,
    actualAmount: 3240,
    userName: '李四',
    userPhone: '13800138002',
    orderTime: '2025-01-15 11:00:00',
    paymentTime: '2025-01-15 11:05:00',
    paymentChannel: '微信',
    status: '已完成',
    type: 'desk'
  },
  {
    id: '3',
    orderNo: 'ORD202501150003',
    paymentNo: '',
    productName: '高性能云电脑',
    productPrice: 800,
    quantity: 1,
    paymentMethod: '包年包月',
    paymentMethodDetail: '包年包月-按年（1年）',
    orderType: '新购',
    orderAmount: 9600,
    discountAmount: 960,
    actualAmount: 8640,
    userName: '王五',
    userPhone: '13800138003',
    orderTime: '2025-01-15 12:00:00',
    paymentTime: '',
    paymentChannel: '支付宝',
    status: '待支付',
    type: 'desk'
  },
  {
    id: '4',
    orderNo: 'ORD202501150004',
    paymentNo: 'PAY202501150004',
    productName: 'AI训练服务器',
    productPrice: 50,
    quantity: 1,
    paymentMethod: '购买时长',
    paymentMethodDetail: '购买时长-小时（3小时）',
    orderType: '续费',
    orderAmount: 150,
    discountAmount: 15,
    actualAmount: 135,
    userName: '赵六',
    userPhone: '13800138004',
    orderTime: '2025-01-15 13:00:00',
    paymentTime: '2025-01-15 13:02:00',
    paymentChannel: '余额',
    status: '已支付',
    type: 'desk'
  },
  {
    id: '5',
    orderNo: 'ORD202501150005',
    paymentNo: '',
    productName: '数据盘',
    productPrice: 0.5,
    quantity: 100,
    paymentMethod: '包年包月',
    paymentMethodDetail: '包年包月-按月（6月）',
    orderType: '新购',
    orderAmount: 300,
    discountAmount: 0,
    actualAmount: 300,
    userName: '孙七',
    userPhone: '13800138005',
    orderTime: '2025-01-15 14:00:00',
    paymentTime: '',
    paymentChannel: '微信',
    status: '已取消',
    type: 'desk'
  },
  {
    id: '6',
    orderNo: 'ORD202501150006',
    paymentNo: 'PAY202501150006',
    productName: 'PC Farm',
    productPrice: 1500,
    quantity: 1,
    paymentMethod: '包年包月',
    paymentMethodDetail: '包年包月-按日（7日）',
    orderType: '新购',
    orderAmount: 350,
    discountAmount: 35,
    actualAmount: 315,
    userName: '周八',
    userPhone: '13800138006',
    orderTime: '2025-01-14 10:00:00',
    paymentTime: '2025-01-14 10:05:00',
    paymentChannel: '支付宝',
    status: '已退款',
    type: 'desk'
  },
  {
    id: '7',
    orderNo: 'ORD202501150007',
    paymentNo: 'PAY202501150007',
    productName: 'AIGC服务',
    productPrice: 3.8,
    quantity: 1,
    paymentMethod: '按时计费',
    paymentMethodDetail: '按时计费-小时（2.5小时）',
    orderType: '新购',
    orderAmount: 9.5,
    discountAmount: 0,
    actualAmount: 9.5,
    userName: '吴九',
    userPhone: '13800138007',
    orderTime: '2025-01-14 15:00:00',
    paymentTime: '2025-01-14 15:02:00',
    paymentChannel: '余额',
    status: '部分退款',
    type: 'desk'
  },
  {
    id: '8',
    orderNo: 'ORD202501150008',
    paymentNo: 'PAY202501150008',
    productName: '标准云电脑',
    productPrice: 600,
    quantity: 1,
    paymentMethod: '包年包月',
    paymentMethodDetail: '包年包月-按月（1月）',
    orderType: '续费',
    orderAmount: 600,
    discountAmount: 60,
    actualAmount: 540,
    userName: '郑十',
    userPhone: '13800138008',
    orderTime: '2025-01-13 09:00:00',
    paymentTime: '2025-01-13 09:03:00',
    paymentChannel: '微信',
    status: '已完成',
    type: 'desk'
  },
  {
    id: '9',
    orderNo: 'RORD202501150001',
    paymentNo: 'RPAY202501150001',
    productName: '路由器服务',
    productPrice: 299,
    quantity: 1,
    paymentMethod: '包年包月',
    paymentMethodDetail: '包年包月-按年（1年）',
    orderType: '新购',
    orderAmount: 3588,
    discountAmount: 358,
    actualAmount: 3230,
    userName: '陈一',
    userPhone: '13800138009',
    orderTime: '2025-01-15 16:00:00',
    paymentTime: '2025-01-15 16:05:00',
    paymentChannel: '支付宝',
    status: '已支付',
    type: 'router'
  },
  {
    id: '10',
    orderNo: 'RORD202501150002',
    paymentNo: '',
    productName: '企业路由器',
    productPrice: 599,
    quantity: 2,
    paymentMethod: '包年包月',
    paymentMethodDetail: '包年包月-按月（6月）',
    orderType: '新购',
    orderAmount: 7188,
    discountAmount: 0,
    actualAmount: 7188,
    userName: '林二',
    userPhone: '13800138010',
    orderTime: '2025-01-15 17:00:00',
    paymentTime: '',
    paymentChannel: '微信',
    status: '待支付',
    type: 'router'
  }
];
